import * as React from "react";
import { useCurrentStudyConfigurationContext } from "../../../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../../../Core/SecurityContext";
import { PermissionEnum } from "../../../../misc/api/ApiPermissionEnum";
import { Authorization } from "../../../../misc/components/Authorization";
import { CorrectionItem } from "../CorrectionItem";

export const MiscCorrectionItem = ({ recordId, isDisabled, onClick, onRemove, correctionSelected }) => {
    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();

    return (
        <Authorization studyId={study.id} currentPermissions={currentUserPermissions} permissionId={PermissionEnum.RequestMiscDCF}>
            <CorrectionItem
                recordId={recordId}
                title="Miscellaneous"
                description="Request any other corrections that are not covered by other actions"
                isDisabled={isDisabled}
                onClick={onClick}
                onRemove={onRemove}
                correctionSelected={correctionSelected}
            />
        </Authorization>
    );
}
